// extracted by mini-css-extract-plugin
module.exports = {"vertical":"styles_vertical__1vM6-","alertsFilter":"styles_alertsFilter__YRJtc"};